webpackJsonp([5],{

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_MetaDecorator__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_images_ourServices_jpg__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_images_ourServices_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__media_images_ourServices_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_images_sharepointOnline_jpg__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_images_sharepointOnline_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__media_images_sharepointOnline_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_images_msPowerPlatform_jpg__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_images_msPowerPlatform_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__media_images_msPowerPlatform_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_images_msTeams_jpg__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_images_msTeams_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__media_images_msTeams_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_images_msAzure_jpg__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_images_msAzure_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__media_images_msAzure_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_images_websites_jpg__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__media_images_websites_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__media_images_websites_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_images_softwareDevelopment_jpg__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__media_images_softwareDevelopment_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__media_images_softwareDevelopment_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__media_images_innovation_jpg__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__media_images_innovation_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__media_images_innovation_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__media_images_convincing_jpg__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__media_images_convincing_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__media_images_convincing_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_images_quality_jpg__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__media_images_quality_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__media_images_quality_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Startsite=function(_Component){_inherits(Startsite,_Component);function Startsite(props){_classCallCheck(this,Startsite);var _this=_possibleConstructorReturn(this,(Startsite.__proto__||Object.getPrototypeOf(Startsite)).call(this,props));_this.updateWindowDimensions=function(){_this.setState({width:window.innerWidth});};_this.sliderRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={width:window.innerWidth};return _this;}_createClass(Startsite,[{key:"componentDidMount",value:function componentDidMount(){var tabs=document.getElementsByClassName("nav-wrapper")[1].querySelectorAll("ul")[0].querySelectorAll("a");for(var i=0;i<tabs.length;i++){tabs[i].removeAttribute("class");if(tabs[i].id==="startsite"){tabs[i].setAttribute("class","orange-text text-darken-4");}}var mobileTabs=document.getElementsByClassName("sidenav")[0].querySelectorAll("a");for(var _i=0;_i<mobileTabs.length;_i++){if(mobileTabs[_i].id==="startsiteMobile"){mobileTabs[_i].removeAttribute("class");mobileTabs[_i].setAttribute("class","orange-text text-darken-4 grey darken-3");}}// var elems = document.querySelectorAll('.slider');
__WEBPACK_IMPORTED_MODULE_1_materialize_css__["Slider"].init(this.sliderRef.current);this.updateWindowDimensions();window.addEventListener("resize",this.updateWindowDimensions.bind(this));}},{key:"render",value:function render(){var width=this.state.width;var isMobile=width<=600;var isTablet=width<=992&&width>600;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__services_MetaDecorator__["a" /* default */],{url:"https://www.jetminds.de",title:"JetMinds | Moderne Informationstechnologien & digitale Transformation",descrption:"Wir gestalten die digitale Transformation in Unternehmen mit dem Ziel digitale Arbeitspl\xE4tze zu schaffen und die routinem\xE4\xDFigen Aktivit\xE4ten auf ein Minimum zu reduzieren"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(!isMobile&&!isTablet?"siteSlider ":"")+"slider",ref:this.sliderRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:(!isMobile&&!isTablet?"siteSlides ":"")+"slides"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__media_images_ourServices_jpg___default.a,alt:"JetMinds Unsere Dienstleistungen",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption left-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Unsere Dienstleistungen"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"Unsere Dienstleistungen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"Leistungsstarker Einsatz digitaler Technologien f\xFCr die Zusammenarbeit, Softwareentwicklung und Webseiten"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche",className:"btn-large orange darken-4",style:{marginTop:"20px",marginRight:"-13px"}},"Mehr erfahren"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche",className:"btn-large orange darken-4",style:{margin:"20px"}},"Mehr erfahren")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4__media_images_sharepointOnline_jpg___default.a,alt:"JetMinds SharePoint Online",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption right-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"SharePoint Online"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"SharePoint Online"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"Beratung, Integration, Support und Wartung, Administration, Migration und ma\xDFgeschneiderte L\xF6sungen auf Basis von SharePoint Online"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/sharepoint-online",className:"btn-large orange darken-4",style:{marginTop:"20px",marginLeft:"-13px"}},"Weitere Details"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/sharepoint-online",className:"btn-large orange darken-4",style:{margin:"20px"}},"Weitere Details")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__media_images_msPowerPlatform_jpg___default.a,alt:"JetMinds Microsoft Power Platform",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption right-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Power Platform"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"Power Platform"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"Effektive L\xF6sungen f\xFCr automatisierte Workflows, hochwertige Datenanalyse, intelligente Gesch\xE4ftsanwendungen und moderne Chatbots"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/power-platform",className:"btn-large orange darken-4",style:{marginTop:"20px",marginRight:"-13px"}},"Mehr Infos"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/power-platform ",className:"btn-large orange darken-4",style:{margin:"20px"}},"Jetzt entdecken")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__media_images_msTeams_jpg___default.a,alt:"JetMinds Microsoft Teams",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption left-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Microsoft Teams"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"Microsoft Teams"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"Das leistungsst\xE4rkste Tool f\xFCr die Zusammenarbeit, ortsunabh\xE4ngig kommunizieren und nahtlos im Team arbeiten"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/microsoft-teams",className:"btn-large orange darken-4"},"zu den Details"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/microsoft-teams",className:"btn-large orange darken-4",style:{margin:"20px"}},"Mehr Information")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7__media_images_msAzure_jpg___default.a,alt:"JetMinds Microsoft Azure",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption left-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Microsoft Azure"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"Microsoft Azure"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"wandelt Ideen mit vertrauensw\xFCrdigen Produkten und Diensten in innovative L\xF6sungen um"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/microsoft-azure",className:"btn-large orange darken-4",style:{marginTop:"20px",marginLeft:"-13px"}},"Information"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/microsoft-azure",className:"btn-large orange darken-4",style:{margin:"20px"}},"Detaillierte Angaben")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9__media_images_softwareDevelopment_jpg___default.a,alt:"JetMinds Softwareentwicklung",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption right-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Software Development"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"Software Development"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"Softwareentwicklung und Softwareberatung f\xFCr komplexe Gesch\xE4ftsl\xF6sungen basierend auf Microsoft 365"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/softwareentwicklung",className:"btn-large orange darken-4",style:{marginTop:"20px",marginRight:"-13px"}},"Weitere aspekte"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/softwareentwicklung",className:"btn-large orange darken-4",style:{margin:"20px"}},"Weitere aspekte")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8__media_images_websites_jpg___default.a,alt:"JetMinds Webseiten",loading:"lazy"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:(isMobile||isTablet?"moduleMobile":"module")+" caption left-align"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Webseiten"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",{className:"center"},"Webseiten"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h6",{className:"text-lighten-3 center"},"Sehr moderne und responsive Webseiten f\xFCr Ihr Unternehmen, die Ihre Pr\xE4senz sehr professionell darstellen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center"},isMobile||isTablet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/webseiten",className:"btn-large orange darken-4"},"N\xE4here Vorteile"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/fokusbereiche/webseiten",className:"btn-large orange darken-4",style:{margin:"20px"}},"Mehr Vorteile")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12 right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:(isMobile?"startTitleM":"startTitle")+" center"},"Dienstleister f\xFCr moderne Informationstechnologien und digitale Transformation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Jeder Tag zeigt sehr deutlich, wie wichtig die digitale Transformation in allen beruflichen sowie privaten Bereichen ist. Leidenschaftlich und mit fester \xDCberzeugung sind wir Vertreter des digitalen Arbeitsplatzes, der Unternehmen Dienstleistungen in f\xFCnf Hauptdimensionen anbietet: Beratung und Konzeption, Kommunikation und Kollaboration, Dokumentenmanagement und Mobilit\xE4t, Smart Business Applications und automatisierte Gesch\xE4ftsprozesse sowie serverless Compute und End-to-End Development. Wir gestalten die digitale Transformation in Unternehmen mit dem Ziel digitale Arbeitspl\xE4tze zu schaffen und die routinem\xE4\xDFigen Aktivit\xE4ten auf ein Minimum zu reduzieren. Dadurch bekommen die Mitarbeiterinnen und Mitarbeiter Zeit und Raum f\xFCr Kreativit\xE4t und somit zu mehr Produktivit\xE4t. Dar\xFCber hinaus bieten wir Schulungen, Software- und Webseitenentwicklungen an."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"developer_board")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Beratung und Konzeption"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Wir stehen Ihnen mit fundierter technischer sowie funktioneller Beratung rund um das Thema moderne Informationstechnologien und digitale Transformation, insbesondere"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/sharepoint-online"},"SharePoint Online"),","," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/power-platform"},"Power Platform"),","," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/microsoft-teams"},"Microsoft Teams")," ","und"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/microsoft-azure"},"Azure")," ","zur Seite. Profitieren Sie von unseren Erfahrungen aus vielen Projekten, die Ihnen den Einstieg in die digitale Transformation erleichtern."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"chrome_reader_mode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Kommunikation und Kollaboration"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Ihre W\xFCnsche, unsere fachlichen Empfehlungen und Erfahrungen sowie die modernen Technologien sind die Roadmap f\xFCr die perfekte Kommunikation- und Kollaborationsplattform, die Ihren Bed\xFCrfnissen und Erwartungen entspricht. Erleben Sie die digitale Zukunft und arbeiten gemeinsam ortsunabh\xE4ngig."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"library_add")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Dokumentenmanagement und Mobilit\xE4t"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Im Bereich DMS haben digitale Funktionen eine sehr wichtige Bedeutung f\xFCr Unternehmen. Wir bieten Ihnen: Struktur durch Zuweisung von Meta-Daten, Sicherheit durch Vergabe von Berechtigungsstufen, Kontrolle durch automatische Versionierungen, Performance durch leistungsstarke Volltextsuchfunktion und vieles mehr.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"apps")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Smart Business Applications und Workflows"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Wir unterst\xFCtzen Ihr Unternehmen beim sofortigen Aufbau und Launching von Smart Business Appications und Add-Ins mit den leistungsst\xE4rksten Technologien von Microsoft wie SharePoint Online, Power Platform und Azure, die die Datenintegration und -verteilung erm\xF6glichen und Ihre Unternehmensplattform mit zahlreichen automatisierten Workflows erweitern."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"all_inclusive")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Serverless Compute und End-to-End Development"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Wir bieten Ihnen eine vollst\xE4ndige End-to-End-Entwicklung von der Erstellung bis zur Bereitstellung und \xDCberwachung in der Cloud. Die Vorteile dieser serverless L\xF6sungen sind u. a. die automatisierte und flexible Skalierung basierend auf Ihrem Workload-Volumen, wobei der Fokus auf der Wertsch\xF6pfung liegt, anstatt die Infrastruktur zu verwalten."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"center orange-text text-darken-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons",style:{fontSize:"35px"}},"code")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"center"},"Softwareentwicklung und Webseiten"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Innovative, ma\xDFgefertigte"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/softwareentwicklung"},"Software- und Webl\xF6sungen")," ","auf Basis von Microsoft SharePoint Online, Azure und Teams f\xFCr Ihre speziellen Anforderungen. Au\xDFerdem bieten wir Ihnen sehr moderne und responsive"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"orange-text text-darken-4",href:"/fokusbereiche/webseiten"},"Webseiten")," ","f\xFCr Ihr Unternehmen, die Ihre Pr\xE4senz sehr professionell und benutzerfreundlich darstellen."))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-image"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"activator",src:__WEBPACK_IMPORTED_MODULE_10__media_images_innovation_jpg___default.a,alt:"JetMinds Innovation",loading:"lazy"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title activator grey-text text-darken-4"},"Innovation",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"more_vert")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"orange-text text-darken-4"},"\u201EKeine Grenzen\u201C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-reveal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title grey-text text-darken-4"},"Innovation",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"close")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Ihre Herausforderungen inspirieren uns zu neuen, kreativen und brillanten Ideen, die zu Ihrem Unternehmenserfolg beitragen.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-image"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"activator",src:__WEBPACK_IMPORTED_MODULE_11__media_images_convincing_jpg___default.a,alt:"JetMinds \xDCberzeugend",loading:"lazy"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title activator grey-text text-darken-4"},"\xDCberzeugend",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"more_vert")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"orange-text text-darken-4"},"\u201ELassen Sie sich beraten\u201C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-reveal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title grey-text text-darken-4"},"\xDCberzeugend",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"close")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Durch Transparenz und Offenheit sowie solide fachliche Kompetenz und Zuverl\xE4ssigkeit gewinnen wir Sie als zufriedenen Kunden.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 "+(isTablet?"m12":"m4")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-image"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"activator",src:__WEBPACK_IMPORTED_MODULE_12__media_images_quality_jpg___default.a,alt:"JetMinds Qualit\xE4t",loading:"lazy"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title activator grey-text text-darken-4"},"Qualit\xE4t",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"more_vert")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"orange-text text-darken-4"},"\u201EGarantiert bemerkenswert\u201C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-reveal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"card-title grey-text text-darken-4"},"Qualit\xE4t",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons right"},"close")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"light"},"Unsere mehrj\xE4hrige Expertise und kontinuierliches Update des neuesten Stands der Technik garantieren unsere hochwertige Arbeit."))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"center section grey lighten-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col s12 m12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4",style:{fontSize:"60px"}},"\u275D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{className:"wisdom"},"Wenn der Wind der Ver\xE4nderung weht, bauen die einen Mauern und die anderen Windm\xFChlen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"orange-text text-darken-4",style:{fontSize:"12px"}},"Altes chinesisches Sprichwort"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null));}}]);return Startsite;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["default"] = (Startsite);

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(723);
var MetaDecorator=function MetaDecorator(_ref){var title=_ref.title,descrption=_ref.descrption,url=_ref.url,noindex=_ref.noindex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["a" /* Helmet */],null,title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,title):"",descrption?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'description',content:descrption}):"",url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'canonical',href:url}):"",noindex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{name:'robots',content:'noindex'}):"");};/* harmony default export */ __webpack_exports__["a"] = (MetaDecorator);

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var _unused_webpack_default_export = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(15);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),

/***/ 725:
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ourServices.9c7c38d9.jpg";

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sharepointOnline.db66b013.jpg";

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/msPowerPlatform.92576b02.jpg";

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/msTeams.f1dc6b80.jpg";

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/msAzure.cdb1249d.jpg";

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/websites.9fbc9fb5.jpg";

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/softwareDevelopment.1e467fbb.jpg";

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/innovation.fb53521e.jpg";

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/convincing.2783ddfd.jpg";

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/quality.c78113b1.jpg";

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.0f7c8e26.chunk.js